import { ChevronsUpDown } from "lucide-react";
import { useSettingsSupplier } from "@/app/Suppliers/Utils/useSettingsSupplier";
import { SupplierIcon } from "@/app/Suppliers/Components/SupplierIcon";
import { SupplierCombobox } from "@/app/Suppliers/Components/SupplierCombobox";

/**
 * Lets an "all suppliers" user pick which supplier the settings screens edit,
 * driven by the `?supplier=` search param. Hidden when a global supplier is
 * already selected (the settings edit that one and the picker would be
 * redundant).
 */
export function SettingsSupplierPicker() {
  const { supplier, supplierId, isGlobalSupplier, setSettingsSupplier } =
    useSettingsSupplier();

  // Hidden when a global supplier is active (settings edit that one) and on the
  // staging screen before a supplier is chosen (the select screen handles that);
  // shown only to switch the already-selected settings supplier.
  if (isGlobalSupplier || !supplierId) {
    return null;
  }

  return (
    <div className="mb-6 flex flex-col gap-2 rounded-lg border border-gray-200 bg-white p-3 shadow-sm sm:flex-row sm:items-center sm:gap-3">
      <span className="text-sm font-medium text-gray-500">
        Editing settings for
      </span>
      <SupplierCombobox
        value={supplierId}
        onChange={setSettingsSupplier}
        renderTrigger={(open) => (
          <button
            role="combobox"
            aria-expanded={open}
            className="flex min-w-56 items-center gap-2 rounded-md border border-gray-300 bg-white px-3 py-1.5 text-left text-sm font-medium text-gray-900 transition-colors hover:bg-gray-50"
          >
            {supplier ? (
              <>
                <SupplierIcon model={supplier} className="size-5 rounded" />
                <span className="flex-1 truncate">{supplier.name}</span>
              </>
            ) : (
              <span className="flex-1 truncate text-gray-500">
                Select a supplier…
              </span>
            )}
            <ChevronsUpDown className="size-4 shrink-0 text-gray-400" />
          </button>
        )}
      />
    </div>
  );
}
